import { c as _c } from "react/compiler-runtime";
/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */
/* eslint-disable jsx-a11y/role-supports-aria-props */
import { CalendarDate } from '@newfront-insurance/string-formatters';
import classnames from 'classnames';
import type { JSX } from 'react';
import { cn } from '../../../v2';
interface Props {
  day: CalendarDate;
  onClick: (date: CalendarDate) => unknown;
  isSelected?: boolean;
  isDisabled?: boolean;
  isCurrentMonth?: boolean;
}
export function DayCell(props) {
  const $ = _c(25);
  const {
    day,
    isSelected,
    isDisabled,
    isCurrentMonth,
    onClick
  } = props;
  let t0;
  if ($[0] !== day || $[1] !== isCurrentMonth || $[2] !== isDisabled || $[3] !== isSelected) {
    const today = CalendarDate.today();
    const isToday = day.isSameDate(today);
    const classNames = classnames({
      DayCell: true,
      isToday,
      isSelected,
      isDisabled,
      isNotThisMonth: !isCurrentMonth
    });
    t0 = cn("hover:bg-muted h-[30px] cursor-pointer rounded-full px-[2px] py-0 focus:ring focus:outline-hidden", {
      "cursor-not-allowed": isDisabled,
      "bg-fire-200 text-fire-500": isToday && !isSelected,
      "text-steel-300": !isCurrentMonth && !isSelected,
      "bg-brand-400 text-white": isSelected,
      "text-steel-300 line-through hover:bg-transparent": isDisabled
    }, classNames);
    $[0] = day;
    $[1] = isCurrentMonth;
    $[2] = isDisabled;
    $[3] = isSelected;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  let t1;
  if ($[5] !== day || $[6] !== isDisabled || $[7] !== onClick) {
    t1 = () => {
      if (isDisabled) {
        return;
      }
      onClick(day);
    };
    $[5] = day;
    $[6] = isDisabled;
    $[7] = onClick;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  let t2;
  if ($[9] !== day || $[10] !== isDisabled || $[11] !== onClick) {
    t2 = e => (e.key === " " || e.key === "Enter") && !isDisabled && onClick(day);
    $[9] = day;
    $[10] = isDisabled;
    $[11] = onClick;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  const t3 = !isDisabled ? 0 : undefined;
  let t4;
  if ($[13] !== day) {
    t4 = day.getDate();
    $[13] = day;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== t4) {
    t5 = <span className="relative flex h-[25px] w-full items-center justify-center rounded-xs text-base text-inherit">{t4}</span>;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== isDisabled || $[18] !== isSelected || $[19] !== t0 || $[20] !== t1 || $[21] !== t2 || $[22] !== t3 || $[23] !== t5) {
    t6 = <td className={t0} onClick={t1} role="button" onKeyDown={t2} tabIndex={t3} aria-selected={isSelected} aria-disabled={isDisabled}>{t5}</td>;
    $[17] = isDisabled;
    $[18] = isSelected;
    $[19] = t0;
    $[20] = t1;
    $[21] = t2;
    $[22] = t3;
    $[23] = t5;
    $[24] = t6;
  } else {
    t6 = $[24];
  }
  return t6;
}
export function EmptyDayCell() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <td className="h-[30px] px-[2px] py-0" aria-label="empty-day-cell" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}